import { useMemo } from 'react';
import { parseISO, format } from 'date-fns';
import { useAppContext } from '../contexts/AppContext';

export function useFilesByDate(filesOverride, sourceIndices) {
  const { files: contextFiles } = useAppContext();
  const files = filesOverride || contextFiles;
  const hasSourceIndexMap =
    Array.isArray(sourceIndices) && sourceIndices.length === files.length;

  const filesByDate = useMemo(() => {
    const grouped = new Map();
    const unassignedFiles = [];
    const unassignedIndices = new Set();

    files.forEach((file, localIndex) => {
      const index = hasSourceIndexMap ? sourceIndices[localIndex] : localIndex;
      const dateStr = file.modifiedExifData?.dateTaken;

      if (!dateStr) {
        unassignedFiles.push(file);
        unassignedIndices.add(index);
        return;
      }

      try {
        // Parse to YYYY-MM-DD format (use local time, not UTC)
        const dateKey = format(parseISO(dateStr), 'yyyy-MM-dd');

        if (!grouped.has(dateKey)) {
          grouped.set(dateKey, []);
        }

        grouped.get(dateKey).push({ file, index });
      } catch (error) {
        // If date parsing fails, treat as unassigned
        unassignedFiles.push(file);
        unassignedIndices.add(index);
      }
    });

    return { grouped, unassigned: unassignedFiles, unassignedIndices };
  }, [files, sourceIndices, hasSourceIndexMap]);

  return filesByDate;
}
